import { useParams, Navigate } from 'react-router';
import { useMyEnrollmentsByCourse } from '@/api/enrollments';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { BackButton } from '@/components/shared/back-button';
import { pickEnrollmentForCourse } from './pick-enrollment';

/**
 * Resolver route for course-level deep-links (notifications carry a course id,
 * but the portal course detail page is enrollment-keyed). Looks up the user's own
 * enrollment for the course and redirects to it, so a "Nueva capacitación
 * asignada" / "Capacitación actualizada" notification lands on the right page.
 */
export function CourseByCoursePage() {
  const { courseId } = useParams<{ courseId: string }>();
  const id = Number(courseId) || 0;
  const { data: enrollments, isLoading, error } = useMyEnrollmentsByCourse(id);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message="No se pudo abrir la capacitación." />;

  const picked = pickEnrollmentForCourse(enrollments ?? []);
  if (!picked) {
    return (
      <div className="space-y-4">
        <BackButton fallback="/courses" label="Volver a Mis Cursos" />
        <ErrorMessage message="No encontramos tu inscripción a esta capacitación." />
      </div>
    );
  }

  return <Navigate to={`/courses/${picked.id}`} replace />;
}
